
const Ticker = ({ text, speed = 15 }) => {
    return (
        <div className="ticker-container">
            <div
                className="ticker-text"
                style={{ animationDuration: `${speed}s` }}
            >
                <span>{text}</span>
                {/* We duplicate the text to ensure a seamless loop */}
                <span>{text}</span>
            </div>
        </div>
    );
};

export default Ticker;